export const LinkedInCircleIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11ZM8.872 9.3h-2.67V18h2.67V9.3Zm.252-2.732C9.124 5.708 8.419 5 7.562 5 6.705 5 6 5.658 6 6.568c0 .86.705 1.568 1.562 1.568.857 0 1.562-.708 1.562-1.568Zm4.031 3.895V9.3h-2.52v8.599h2.671v-4.3c0-1.113.202-2.226 1.613-2.226 1.41 0 1.41 1.316 1.41 2.327v4.25H19v-4.755c0-2.327-.504-4.148-3.225-4.148-1.31 0-2.217.708-2.57 1.416h-.05Z"
      clipRule="evenodd"
    />
  </svg>
);
